// Import hooks.
import {
	useInputForm,
	UseInputFormResult,
} from '@app/hooks/view/input';
// Import app models.
import {
	ValidatorResponse,
} from '@app/models/app';
// Import props.
import {
	InputFormProps,
	InputTextWithoutInputTextBoxProps,
} from '@app/props';
// Import services.
import {
	AddressService,
} from '@app/services';

interface UseInputPostalCodeParameters {
	id: string;
	label: string;
	required: boolean;
	disabled: boolean;
	value: string;
	showValidation?: boolean;
}

type UseInputPostalCodeResults = UseInputFormResult<string, InputTextWithoutInputTextBoxProps>

const useInputPostalCode = (params: UseInputPostalCodeParameters): UseInputPostalCodeResults => {

	// #region exported methods

	/**
	 * Returns props for form input. 
	 **/
	const applyPostalCodeInputProps = (): InputTextWithoutInputTextBoxProps => {
		// First apply the form input props.
		let formProps: InputFormProps = applyProps();
		// Then apply the dropdown props.
		return {
			...formProps,
			onChange: other.setInput,
			value: other.value,
		}
	};

	// #endregion exported methods


	/**
	 * Validates the current value.
	 * @param value
	 */
	const validateText = (value: string, required: boolean): ValidatorResponse => {
		let response: ValidatorResponse = new ValidatorResponse(true, String.empty());

		if (required
			&& String.isNullOrWhiteSpace(value)) {
			// Make sure there is a zip code value, if required.
			response = new ValidatorResponse(false, 'Zip code is required.');
		}
		else if (!String.isNullOrWhiteSpace(value)
			&& !AddressService.getInstance().isStringZipFormat(value)) {
			// Make sure the zip code value is valid, if a value is provided.
			response = new ValidatorResponse(false, 'Zip code is invalid.');
		}

		return response;
	}

	// #endregion private methods


	// #region variables

	// Instantiate the 'address' input.
	const { applyProps, ...other } = useInputForm<string>({
		id: params.id,
		label: params.label,
		required: params.required,
		disabled: params.disabled,
		initialInput: params.value,
		showValidation: params.showValidation,
		validators: [validateText],
	});

	// #endregion variables


	return {
		applyProps: applyPostalCodeInputProps,
		...other,
	};
}

// Export parameters.
export {
	UseInputPostalCodeParameters,
}

// Export results.
export {
	UseInputPostalCodeResults,
}

export default useInputPostalCode;